import { EmailSetup } from "0.Mine/3.Interfaces/emailAccount";

import { useQlickupAPI, QlickupActions } from "../APICall";

export const UseEmailSetup = () => {
  const { QlickUpAPI } = useQlickupAPI();

  const addEmailSetup = async (businessid: string, data: EmailSetup) => {
    const response = await QlickUpAPI(businessid, "add", data, "email_setup", QlickupActions.POST);
    console.log(response);
  };

  const getEmailSetup = async (businessid: string) => {
    const response = await QlickUpAPI(
      businessid,
      "getall",
      null,
      "email_setup",
      QlickupActions.GET
    );
    console.log(response);

    return response.configs as EmailSetup[];
  };

  return { addEmailSetup, getEmailSetup };
};
